import React from 'react';

const ArrowDown = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 12 7" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="ArrowDown_a" d="M349.3 804l1.36 1.33-5.83 5.67-5.83-5.67 1.36-1.33 4.47 4.35z" />
    </defs>
    <use fill="currentColor" xlinkHref="#ArrowDown_a" transform="translate(-339 -804)" />
  </svg>
);

export default ArrowDown;



// WEBPACK FOOTER //
// ./src/common/icons/ArrowDown.js